import {Container} from "react-bootstrap";
import React from "react";
export default function CompleteSwiftWiresButton(props) {
    return (<>
        <Container fluid className={props.isActionColBtn?"d-none":"m-0 p-0"}>
            <a href="#" onClick={props.onCompleteSwiftWiresClick}>
                <span className='d-md-block'>{props.buttonTitle}</span>
            </a>
        </Container>
        <Container fluid className={!props.isActionColBtn?"d-none":"m-0 p-0"}>
            <button className="btn btn-block td-btn-primary-light my-3" href="#" onClick={props.onCompleteSwiftWiresClick}>
                {props.buttonTitle??'Complete'}
            </button>
        </Container>
    </>)
}
